import { createContext } from 'react'

type FormSubmit = () => Promise<void>
interface FormSubmitContextValue {
  readonly submit: FormSubmit
  readonly apply?: FormSubmit
}

export const FormSubmitContext = createContext<FormSubmitContextValue>({
  submit: () => Promise.reject(new Error('Missing FormSubmitContext')),
})
